export default "__VITE_ASSET__BenY0hfu__"